import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { ImBin } from "react-icons/im";
import { FaRegAddressBook } from "react-icons/fa";
import { IoPricetagOutline } from "react-icons/io5";

const QuoteInternal = () => {
  const [desiredServices, setDesiredServices] = useState([]);
  const [quotes, setQuotes] = useState([]);
  const [quoteSessionUUID, setQuoteSessionUUID] = useState(null);
  const [customerPostcode, setCustomerPostcode] = useState(null);
  const [desiredQuote, setDesiredQuote] = useState(null);
  const [quoteAcceptConfirm, setQuoteAcceptConfirm] = useState(false);
  const pages = [
    { page: "postcode", title: "Postcode", icon: <FaRegAddressBook /> },
    { page: "waste-services", title: "Services", icon: <ImBin /> },
    { page: "quote-selection", title: "Quotes", icon: <IoPricetagOutline /> },
  ];

  const navigate = useNavigate();
  useEffect(() => {
    navigate("/internal-quote/postcode");
  }, []);

  return (
    <>
      <div className="flex size-full flex-col">
        <Outlet
          context={[
            customerPostcode,
            setCustomerPostcode,
            desiredServices,
            setDesiredServices,
            setQuotes,
            setQuoteSessionUUID,
            quotes,
            setDesiredQuote,
            setQuoteAcceptConfirm,
            desiredQuote,
            quoteAcceptConfirm,
            quoteSessionUUID,
            pages,
          ]}
        />
      </div>
    </>
  );
};

export default QuoteInternal;
